import { SPECIAL_PRODUCT_TYPES_ARR } from 'swag-common/constants/product.constants';
export function isBundle(product) {
  var _product$bundleConten;
  return Boolean((product === null || product === void 0 ? void 0 : (_product$bundleConten = product.bundleContent) === null || _product$bundleConten === void 0 ? void 0 : _product$bundleConten.length) > 0);
}
export function isBundleAddon(product) {
  return SPECIAL_PRODUCT_TYPES_ARR.includes(product === null || product === void 0 ? void 0 : product.specialProductType);
}